import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Banner, Footer, Body, Popup, Header } from '@calendly/ui/components/popup'
import { useDispatch, useSelector } from 'react-redux'

import { fetchCurrentSubscriptionAndNextBill } from 'features/billing/actions/fetch_current_subscription_and_next_bill'
import { resetCreateSubscription } from 'features/billing/create_subscription_slice'
import { humanizePlan } from 'features/billing/helpers'
import { SuccessBanner } from 'features/billing/modals/success_banner'
import { subscriptionPlanSelector, scheduledChangeTypeSelector, subscriptionQuantitySelector } from 'features/billing/selectors'

import { isLoadingSelector } from './selectors'
import { reset as resetPromptToRemoveScheduledDowngrade } from './slice'
import { Paragraph } from './styles'

export const Success = () => {
  const dispatch = useDispatch()

  const currentPlan = humanizePlan(useSelector(subscriptionPlanSelector))
  const scheduledChangeType = useSelector(scheduledChangeTypeSelector)
  const currentQuantity = useSelector(subscriptionQuantitySelector)
  const isLoading = useSelector(isLoadingSelector)

  const onClose = () => {
    dispatch(resetCreateSubscription())
    dispatch(fetchCurrentSubscriptionAndNextBill())
  }

  const onCloseSuccess = async () => {
    dispatch(resetCreateSubscription())
    dispatch(fetchCurrentSubscriptionAndNextBill())
    dispatch(resetPromptToRemoveScheduledDowngrade())
  }

  return (
    <Popup onClose={onClose}>
      <Banner size="large">
        <SuccessBanner />
      </Banner>
      <Header title={I18n.t('publisher.billing.scheduled_downgrade.prompt_to_remove_modal.success_title')} />
      <Body>
        <Paragraph>
          {scheduledChangeType === 'plan'
              && I18n.t('publisher.billing.scheduled_downgrade.prompt_to_remove_modal.success_text.plan',
                { old_plan: currentPlan }
              )}
          {scheduledChangeType === 'quantity'
              && I18n.t('publisher.billing.scheduled_downgrade.prompt_to_remove_modal.success_text.quantity',
                { count: currentQuantity }
              )}
        </Paragraph>
      </Body>
      <Footer>
        <Button
          loading={isLoading}
          onClick={onCloseSuccess}
        >
          {I18n.t('publisher.billing.scheduled_downgrade.prompt_to_remove_modal.success_button')}
        </Button>
      </Footer>
    </Popup>
  )
}
